import type { Lane, RemoteDriver, TrafficEvent } from "../../types/traffic";
import type {
  CohortConnectionInput,
  RealtimeListener,
  TrafficRealtimeProvider,
} from "./TrafficRealtimeProvider";

export class OfflineTrafficRealtimeProvider implements TrafficRealtimeProvider {
  private readonly listeners = new Set<RealtimeListener>();

  public connect(_input: CohortConnectionInput): Promise<void> {
    this.emit({ type: "snapshot", drivers: [] });
    this.emit({ type: "connection", state: "offline" });
    return Promise.resolve();
  }

  public reconnect(input: CohortConnectionInput): Promise<void> {
    return this.connect(input);
  }

  public updateLane(_lane: Lane): Promise<void> {
    return Promise.resolve();
  }

  public updatePresence(_driver: RemoteDriver): Promise<void> {
    return Promise.resolve();
  }

  public publish(_event: TrafficEvent): Promise<void> {
    return Promise.resolve();
  }

  public disconnect(): Promise<void> {
    this.emit({ type: "connection", state: "offline" });
    return Promise.resolve();
  }

  public isConnected(): boolean {
    return false;
  }

  public subscribe(listener: RealtimeListener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  private emit(update: Parameters<RealtimeListener>[0]): void {
    this.listeners.forEach((listener) => listener(update));
  }
}
